"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPoolAuditActionToJSON = exports.CommunityPoolAuditActionFromJSONTyped = exports.CommunityPoolAuditActionFromJSON = exports.CommunityPoolAuditAction = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var CommunityPoolAuditAction;
(function (CommunityPoolAuditAction) {
    CommunityPoolAuditAction["USERINVITED"] = "USER_INVITED";
    CommunityPoolAuditAction["USERJOINED"] = "USER_JOINED";
    CommunityPoolAuditAction["CONVERSIONAPPROVED"] = "CONVERSION_APPROVED";
    CommunityPoolAuditAction["CONVERSIONDECLINED"] = "CONVERSION_DECLINED";
    CommunityPoolAuditAction["USERREVOKED"] = "USER_REVOKED";
    CommunityPoolAuditAction["CONFIGUPDATED"] = "CONFIG_UPDATED";
    CommunityPoolAuditAction["MANUALCOMMITMENTDELETED"] = "MANUAL_COMMITMENT_DELETED";
})(CommunityPoolAuditAction = exports.CommunityPoolAuditAction || (exports.CommunityPoolAuditAction = {}));
function CommunityPoolAuditActionFromJSON(json) {
    return CommunityPoolAuditActionFromJSONTyped(json, false);
}
exports.CommunityPoolAuditActionFromJSON = CommunityPoolAuditActionFromJSON;
function CommunityPoolAuditActionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CommunityPoolAuditActionFromJSONTyped = CommunityPoolAuditActionFromJSONTyped;
function CommunityPoolAuditActionToJSON(value) {
    return value;
}
exports.CommunityPoolAuditActionToJSON = CommunityPoolAuditActionToJSON;
